export enum EHackTerminalAchievments {
  WIN = "WIN",
  SAVE_WIN = "SAVE_WIN",
  WIN_IN_ROW = "WIN_IN_ROW",
}
